import { faVideo } from "@fortawesome/duotone-light-svg-icons"
import { Button } from "@joonapp/web-shared"
import { SessionBooking } from "@joonapp/web-shared"

import useUserRole from "../../../../hooks/useUserRole"
import useSession from "../hooks/useSession"

const JoinSessionButton = ({ session }: { session: SessionBooking }) => {
  const { handleJoinSession, showJoinButton } = useSession(session)
  const { isClientOfOtherCoach } = useUserRole()
  if (!showJoinButton) return <></>

  return (
    <Button
      text="Join session"
      icon={faVideo}
      buttonType="primary"
      onClick={handleJoinSession}
      disabled={isClientOfOtherCoach}
    />
  )
}

export default JoinSessionButton
